/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · French (fr) string table
   English is the source of truth in the HTML; this file supplies the
   French counterpart for each data-i18n key. Missing keys fall back to
   English automatically (see i18n.js). Hand this file to a translator or
   compliance reviewer; it is the single place French copy lives.

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) stay in English. Informal "tu", never "vous"
   for singular address. Standalone "serum" → "sérum".
═════════════════════════════════════════════════════════════════════ */
window.TD_I18N = window.TD_I18N || {};
window.TD_I18N.fr = Object.assign(window.TD_I18N.fr || {}, {

  /* ── Nav (site-wide) ── */
  'nav.shop': 'Boutique',
  'nav.science': 'Science',
  'nav.concerns': 'Besoins de la peau',
  'nav.story': 'Notre histoire',
  'nav.contact': 'Contact',
  'nav.tryus': 'Essaie-nous',
  'nav.faq': 'Questions fréquentes',
  'nav.drawerCta': 'Essaie-nous · Discovery Kit',
  'nav.drawerFine': 'Cinq sérums vitaminés · $70 · livraison dans le monde entier',

  /* ── Announcement bar (site-wide) ── */
  'announce.0a': '<strong>Livraison gratuite</strong> pour toute commande de plus de $150',
  'announce.0b': 'Expédié dans le monde entier depuis Stockholm',
  'announce.1a': '<strong>Crée une routine et économise 10%</strong>',
  'announce.1b': 'Appliqué automatiquement au paiement',
  'announce.2a': 'Essaie les cinq sérums.',
  'announce.2b': '<strong>Livraison gratuite dès $150</strong>',

  /* ── Homepage · hero ── */
  'home.hero.tagline': 'Soin de la peau sans compromis · Est. 1998',
  'home.hero.h1': '<span class="l1">Sans eau.</span><br><span class="l2">Sans conservateurs.</span><br><span class="l3">Sans additifs.</span><br><span class="l4">Sans colorants.</span><br><span class="l5">Sans air.</span><br><span class="l6"><em class="hero-vitamins-em">Uniquement des vitamines actives.</em></span>',
  'home.hero.sub': 'Formulés pour une véritable absorption dermique au-delà de la surface.<br>Cinq sérums vitaminés. Cinq non. Un système.',
  'home.hero.cta1': 'Explore les sérums',
  'home.hero.cta2': 'Comment ça fonctionne',

  /* ── Homepage · coming-soon teaser (static only) ── */
  'home.cs.title': 'Campagne<br><em>Été</em> 2026',
  'home.cs.shop': 'Sérums disponibles maintenant',

  /* ── Homepage · press bar ── */
  'home.press.label': 'Vu dans',

  /* ── Homepage · collection ── */
  'home.coll.eyebrow': 'La collection',
  'home.coll.h2': 'Sérums vitaminés formulés avec précision. <em>Développés à Stockholm.</em>',
  'home.coll.viewAll': 'Voir tous les produits',
  'home.coll.c.benefit': 'Protège, illumine et raffermit avec de la vitamine C pure.',
  'home.coll.a.benefit': 'Renouvellement au rétinol pendant ton sommeil.',
  'home.coll.o.benefit': 'Stimule les cellules et redonne de l’éclat visible.',
  'home.coll.m.benefit': 'Répare la barrière hydratante. En profondeur et durablement.',
  'home.coll.r.benefit': 'Raffermit et restaure. Réduit l’apparence des imperfections, des marques post-acné et des irrégularités de texture au fil du temps.',
  'home.coll.kit.name': 'Discovery Kit',
  'home.coll.kit.benefit': 'Les cinq sérums au format poche. Essaie le système complet avant de te décider.',
  'home.coll.kit.badge': 'Nouveau',

  /* ── Homepage · science intro (shared) ── */
  'home.science.eyebrow': 'La science',
  'home.science.h2': 'La pénétration profonde fait<br><em>la différence.</em>',
  'home.science.body': 'Le système de transport de Transderma achemine les vitamines actives au-delà de l’épiderme jusque dans le derme, là où se produisent la synthèse du collagène et le renouvellement cellulaire.',
  'home.science.readMore': 'Lire toute la science →',

  /* ── Homepage · science skin diagram (static only) ── */
  'home.sci.serumLabel': 'Sérums<br>Transderma',
  'home.sci.l1.label': 'STRATUM CORNEUM',
  'home.sci.l1.desc': 'Couche la plus externe de la peau',
  'home.sci.l1.p': 'Le stratum corneum est la barrière externe de la peau : des cellules mortes et compactées qui bloquent la majeure partie de ce que nous appliquons. La formule sans eau de Transderma le traverse en quelques secondes après l’application. Les vitamines actives atteignent intactes les tissus vivants en dessous, sans perte par évaporation.',
  'home.sci.l1.depth': '0 mm DE PROFONDEUR',
  'home.sci.l2.label': 'ÉPIDERME',
  'home.sci.l2.desc': 'Cellules vivantes de la peau, mélanocytes, terminaisons nerveuses',
  'home.sci.l2.p': 'La plupart des sérums s’arrêtent ici, déposés parmi les cellules vivantes de l’épiderme, incapables d’aller plus loin. Transderma ne contient pas d’eau, donc chaque goutte conserve toute sa concentration en vitamines pendant son trajet. Rien n’est dilué en chemin ; la formule continue d’avancer vers le derme.',
  'home.sci.l2.depth': '0,1 mm DE PROFONDEUR',
  'home.sci.l2.stop': 'La plupart des sérums s’arrêtent ici',
  'home.sci.barrier': 'BARRIÈRE CUTANÉE',
  'home.sci.l3.label': 'COUCHE DERMIQUE',
  'home.sci.l3.desc': 'Collagène, élastine, fibroblastes, vaisseaux sanguins',
  'home.sci.l3.p': 'Le derme est l’endroit où se produit réellement le changement durable de la peau : le collagène, l’élastine et le renouvellement cellulaire commencent ici. Transderma transporte des vitamines concentrées directement dans cette couche, où les fibroblastes peuvent les utiliser. C’est la couche que les sérums conventionnels atteignent rarement, et la raison pour laquelle nos résultats se voient au fil des semaines.',
  'home.sci.l3.depth': '1–2 mm DE PROFONDEUR',
  'home.sci.l4.label': 'TISSU SOUS-CUTANÉ',
  'home.sci.l4.desc': 'Tissu adipeux et soutien structurel profond',
  'home.sci.l4.p': 'Sous le derme se trouve la couche sous-cutanée, un tissu adipeux qui ancre la peau et maintient sa forme. À cette profondeur, les vitamines de Transderma ont déjà été absorbées par le derme situé au-dessus. Le tissu ici est la base structurelle du renouvellement qui se produit dans chaque couche construite par-dessus.',
  'home.sci.l4.depth': '4–10 mm DE PROFONDEUR',
  'home.sci.reach': 'TRANSDERMA ATTEINT CETTE PROFONDEUR',

  /* ── Homepage · purity / five nos (static + theme strip) ── */
  'home.purity.eyebrow': 'La différence',
  'home.purity.h2': 'Pas ce à quoi<br><em>tu t’attends.</em>',
  'home.purity.water.title': 'Sans eau',
  'home.purity.water.body': 'Formule sans eau. Concentration plus élevée, pénétration plus profonde.',
  'home.purity.preserv.title': 'Sans conservateurs',
  'home.purity.preserv.body': 'Sans eau, les microbes ne peuvent pas se développer. Aucun n’est nécessaire.',
  'home.purity.fillers.title': 'Sans additifs',
  'home.purity.fillers.body': 'Chaque ingrédient est fonctionnel. Pas d’émulsifiants, d’épaississants ni d’agents de remplissage.',
  'home.purity.dyes.title': 'Sans colorants',
  'home.purity.dyes.body': 'La teinte que tu vois provient des actifs bruts, pas d’une couleur ajoutée.',
  'home.purity.air.title': 'Sans air',
  'home.purity.air.body': 'Scellé dans une pompe airless. Pleine puissance, de la première goutte à la dernière.',

  /* ── Homepage · pure formulation strip header (liquid only) ── */
  'home.strip.eyebrow': 'Formulation pure',
  'home.strip.h3': 'Uniquement des vitamines actives.<br><em>Rien d’autre.</em>',

  /* ── Homepage · trust commitments (liquid only) ── */
  'home.trust.cruelty': '<strong>Jamais testé sur les animaux.</strong> Sans cruauté depuis le premier jour.',
  'home.trust.vegan': '<strong>Formulations véganes.</strong> Aucun ingrédient d’origine animale.',
  'home.trust.made': '<strong>Fabriqué à Stockholm.</strong> Approuvé en laboratoire par Läkemedelsverket.',
  'home.trust.eu': '<strong>Enregistré comme cosmétique dans l’UE.</strong> Vendu dans des cliniques de 14 pays.',

  /* ── Homepage · airless section (liquid only) ── */
  'home.airless.eyebrow': 'Conception airless',
  'home.airless.h2': 'Scellé du premier coup de pompe<br><em>jusqu’au dernier.</em>',
  'home.airless.body': 'L’air est ce qui fait vieillir un sérum. La pompe airless ferme cette porte. La dernière goutte a la même puissance que la première.',

  /* ── Homepage · sample / discovery kit ── */
  'home.sample.eyebrow': 'Tu ne sais pas par où commencer ?',
  'home.sample.h2': 'Essaie les cinq<br><em>pour $70.</em>',
  'home.sample.body': 'Le Transderma Discovery Kit contient des versions format poche des cinq sérums et un guide imprimé pour construire ta routine. C’est ainsi que la plupart de nos clients de longue date nous ont découverts pour la première fois.',
  'home.sample.bodyTheme': 'Le Transderma Discovery Kit contient des versions format poche des cinq sérums. C’est ainsi que la plupart de nos clients de longue date nous ont découverts pour la première fois.',
  'home.sample.cta': 'Obtenir le Discovery Kit',
  'home.sample.fine': '$5 de livraison · Inclut le guide imprimé des besoins de la peau',
  'home.sample.fineTheme': '$5 de livraison dans le monde entier · Expédié depuis Stockholm',
  'home.sample.f1.h': 'Les cinq sérums',
  'home.sample.f1.p': 'Format poche, parfait pour celles et ceux qui sont en déplacement. Environ 7 jours d’utilisation régulière.',
  'home.sample.f1.pTheme': 'Flacons format poche de 3 ml, parfaits pour celles et ceux qui sont en déplacement. Environ 7 jours d’utilisation régulière par flacon.',
  'home.sample.f2.h': 'Guide des besoins de la peau',
  'home.sample.f2.p': 'Un guide imprimé pour t’aider à trouver les sérums qui correspondent à tes besoins spécifiques.',
  'home.sample.f2.hTheme': 'Les cinq, côte à côte',
  'home.sample.f2.pTheme': 'Teste chaque formule dans ta routine au cours de la même semaine et trouve les combinaisons qui fonctionnent pour ta peau.',
  'home.sample.f3.h': 'Sans engagement',
  'home.sample.f3.p': 'Découvre si Transderma te convient. La plupart le savent en quelques jours.',

  /* ── Homepage · skin concerns ── */
  'home.conc.eyebrow': 'Trouve ta formule',
  'home.conc.h2': 'Achète selon<br><em>les besoins de ta peau.</em>',
  'home.conc.firm.t': 'Fermeté',
  'home.conc.firm.d': 'Perte d’élasticité et de définition au niveau de la mâchoire et des joues.',
  'home.conc.bright.t': 'Éclat',
  'home.conc.bright.d': 'Teint inégal, manque d’éclat et décoloration dus à l’exposition environnementale, aux cicatrices ou aux marques post-acné.',
  'home.conc.hydrate.t': 'Hydratation',
  'home.conc.hydrate.d': 'Peau sèche, desquamation et barrière hydratante affaiblie qui ne retient plus.',
  'home.conc.lines.t': 'Ridules',
  'home.conc.lines.d': 'Ridules superficielles et rides d’expression plus profondes qui se développent au fil du temps.',
  'home.conc.viewAll': 'Voir tous les besoins de la peau →',

  /* ── Homepage · heritage / founder ── */
  'home.her.caption': 'Dr. Klaus Alvin Ronlán, Ph.D.<br><span>1942 — 2018 · Maître de conférences</span>',
  'home.her.eyebrow': 'Le fondateur',
  'home.her.h2': 'Trente ans.<br><em>La même formule.</em>',
  'home.her.body': 'Transderma est né dans un laboratoire de Stockholm, fondé par le Dr Klaus Alvin Ronlán après vingt-cinq années de recherche à l’Université de Lund. Cinq sérums, lancés en 1998. Préservés inchangés depuis le décès du Dr Ronlán en 2018. Toujours détenu de façon indépendante. Toujours fabriqué en Suède.',
  'home.her.bodyTheme': 'Transderma est né dans un laboratoire de Stockholm, fondé par le Dr Klaus Alvin Ronlán après vingt-cinq années de recherche. Toujours détenu de façon indépendante. Toujours fabriqué en Suède.',
  'home.her.cta': 'Lis l’histoire du Dr Ronlán →',

  /* ── Awards · Recognition (site-wide) ── */
  'awards.label': 'Reconnu',
  'awards.serumC': 'Nordic Natural Beauty Awards · Lauréat 2020',
  'awards.serumA': 'Global Makeup Awards · Silver, Scandinavie 2022',
  'awards.serumO': 'Swedish Beauty &amp; Cosmetics Awards · Lauréat 2016',
  'awards.serumM': 'Nordic Natural Beauty Awards · Lauréat 2020',
  'awards.serumR': 'ELLE Sweden Beauty Awards · Lauréat 2013',
  'awards.fullLine': 'Reconnu par · ELLE Sweden Beauty Awards · Nordic Natural Beauty Awards · Swedish Beauty &amp; Cosmetics Awards · Global Makeup Awards · LUXlife Magazine',
  'awards.aboutLine': 'Reconnu · ELLE Sweden 2013 · Swedish Beauty &amp; Cosmetics 2016 · Nordic Natural Beauty 2020 · Global Makeup 2022 · LUXlife 2021',

  /* ── Press pull-quotes (real editorial reviews) ── */
  'quote.home.text': '«Soin de la peau hautement efficace, à son meilleur niveau.»',
  'quote.home.cite': 'Melissa Davis · The Beauty Librarian',
  'quote.serumR.text': '«Comme par magie pour la peau. Mon problème de pigmentation sur la lèvre supérieure a disparu.»',
  'quote.serumR.cite': 'Teresa Grundin · Styleby, 2014',
  'quote.serumC.text': '«La science derrière ce produit et la simplicité de la formule sont impressionnantes.»',
  'quote.serumC.cite': 'Truth In Aging',
  'quote.serumA.text': '«Soin de la peau maximisé. Transderma A et C.»',
  'quote.serumA.cite': 'Teresa Grundin · Elle.se, 2014',

  /* ── Footer (site-wide) ── */
  'footer.tagline': 'Est. 1998 · Stockholm',
  'footer.location': 'Stockholm, Suède',
  'footer.col.serums': 'Sérums',
  'footer.col.shop': 'Boutique',
  'footer.col.learn': 'Découvrir',
  'footer.col.support': 'Service client',
  'footer.serums.kit': 'Discovery Kit',
  'footer.serums.gift': 'Cartes cadeaux',
  'footer.shop.all': 'Tous les sérums',
  'footer.learn.research': 'Recherches du Dr Ronlán',
  'footer.learn.science': 'La science',
  'footer.learn.concerns': 'Besoins de la peau',
  'footer.learn.story': 'Notre histoire',
  'footer.learn.about': 'À propos du Dr Ronlán',
  'footer.support.faq': 'Questions fréquentes',
  'footer.support.shipping': 'Livraison &amp; retours',
  'footer.support.stockists': 'Points de vente',
  'footer.support.contact': 'Contact',
  'footer.support.privacy': 'Confidentialité',
  'footer.support.terms': 'Conditions',
  'footer.copy': '© 2026 Transderma®. Tous droits réservés. Stockholm, Suède.<svg class="ft-flag" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg" aria-label="France"><rect width="20" height="40" fill="#0055A4"/><rect x="20" width="20" height="40" fill="#FFFFFF"/><rect x="40" width="20" height="40" fill="#EF4135"/></svg>',
  'footer.links.privacy': 'Confidentialité',
  'footer.links.terms': 'Conditions',

  /* ── Certifications strip (homepage) ── */
  'certifications.label': 'Certifications',
  'certifications.ewg': 'EWG Vérifié',
  'certifications.certclean': 'CertClean Certifié'

});
